<template>
  <div class="article-image">
    <div v-for="index in imageList.length" :key="index" class="item">
      <img class="pic" v-lazy="handleImgSize(imageList[index - 1], 'list')" :alt="index" />
      <div v-if="count > 3 && index == 3" class="balance">
        <img class="icon" src="@/assets/zs_imgs/image-icon.png" />
        <span class="txt">+{{ count - 3 }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ArticleImage",
  props: {
    count: { type: Number, default: 0 },
    imageList: { type: Array, default: () => [] }
  }
};
</script>
<style lang="less" scoped>
.article-image {
  display: flex;
  gap: 8px;
  .item {
    position: relative;
    .pic {
      width: 120px;
      height: 120px;
      border-radius: 8px;
      display: block;
      object-fit: cover;
    }
    .balance {
      position: absolute;
      right: 5px;
      bottom: 5px;
      height: 18px;
      display: flex;
      align-items: center;
      padding: 0 2px;
      gap: 2px;
      color: #fff;
      background-color: rgba(0, 0, 0, 0.8);
      border-radius: 4px;
      .icon {
        height: 14px;
      }
    }
  }
}
</style>
